// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stonex-avatar{border:solid 3px #fff;box-shadow:0 8px 16px rgba(0,0,0,.1);border-radius:50%;cursor:pointer;background-size:cover}", ""]);
// Exports
module.exports = exports;
